import React from "react";
import { publishProgressLabel } from "../utils/articlePublishProgress";
import "./ArticlePublishProgress.css";

export default function ArticlePublishProgress({
    percent = 0,
    phase = "preparing",
    strings = {},
    isInternal = false,
}) {
    const value = Math.max(0, Math.min(100, Math.round(Number(percent) || 0)));
    return (
        <div className="article-publish-progress-screen" role="progressbar" aria-valuemin={0} aria-valuemax={100} aria-valuenow={value}>
            <div className="article-publish-progress-card">
                <div className="article-publish-progress-label">
                    {publishProgressLabel(phase, strings)}
                </div>
                <div className="article-publish-progress-track">
                    <div
                        className={`article-publish-progress-fill article-publish-progress__fill${isInternal ? " article-publish-progress__fill--internal" : ""}`}
                        style={{ "--progress": `${value}%` }}
                    />
                </div>
                <div className="article-publish-progress-pct">{value}%</div>
            </div>
        </div>
    );
}
